// User reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const LOADING_USER = "LOADING_USER";
export const STOP_LOADING_USER = "STOP_LOADING_USER";
export const MARK_NOTIFICATIONS_READ = "MARK_NOTIFICATIONS_READ";

// Social Media Profile Types
export const SET_PINTEREST_PROFILES = "SET_PINTEREST_PROFILES";
export const SET_FAILING_PINTEREST_PROFILES = "SET_FAILING_PINTEREST_PROFILES";
export const SET_FAILING_AUTHORIZED_PROFILES =
  "SET_FAILING_AUTHORIZED_PROFILES";

// Generic social media profile types
export const SET_SOCIAL_MEDIA_PROFILES = "SET_SOCIAL_MEDIA_PROFILES";
export const SET_ACTIVE_SOCIAL_MEDIA_PROFILES =
  "SET_ACTIVE_SOCIAL_MEDIA_PROFILES";
export const ADD_SOCIAL_MEDIA_PROFILE = "ADD_SOCIAL_MEDIA_PROFILE";
export const UPDATE_SOCIAL_MEDIA_PROFILE = "UPDATE_SOCIAL_MEDIA_PROFILE";
export const REMOVE_SOCIAL_MEDIA_PROFILE = "REMOVE_SOCIAL_MEDIA_PROFILE";
export const ACTIVATE_SOCIAL_MEDIA_PROFILE = "ACTIVATE_SOCIAL_MEDIA_PROFILE";
export const SET_SOCIAL_MEDIA_LOADING = "SET_SOCIAL_MEDIA_LOADING";

// Scheduling and Posts
export const SET_SCHEDULING_SETTINGS = "SET_SCHEDULING_SETTINGS";
export const SET_SCHEDULED_POSTS = "SET_SCHEDULED_POSTS";
export const ADD_SCHEDULED_POSTS = "ADD_SCHEDULED_POSTS";
export const SET_SCHEDULED_POST = "SET_SCHEDULED_POST";
export const ADD_NEW_SCHEDULED_POST = "ADD_NEW_SCHEDULED_POST";
export const DELETE_SCHEDULED_POST = "DELETE_SCHEDULED_POST";
export const UPDATE_SCHEDULED_POSTS = "UPDATE_SCHEDULED_POSTS";
export const SET_IS_LOADING_SCHEDULED_POSTS = "SET_IS_LOADING_SCHEDULED_POSTS";
export const SET_REPEATING_POSTS = "SET_REPEATING_POSTS";
export const ADD_REPEATING_POSTS = "ADD_REPEATING_POSTS";
export const SET_REPEATING_POST = "SET_REPEATING_POST";
export const ADD_NEW_REPEATING_POST = "ADD_NEW_REPEATING_POST";
export const DELETE_REPEATING_POST = "DELETE_REPEATING_POST";
export const UPDATE_REPEATING_POSTS = "UPDATE_REPEATING_POSTS";
export const SET_IS_LOADING_REPEATING_POSTS = "SET_IS_LOADING_REPEATING_POSTS";

// User Management
export const INCREMENT_USED_POST_CREDITS = "INCREMENT_USED_POST_CREDITS";
export const DECREMENT_USED_POST_CREDITS = "DECREMENT_USED_POST_CREDITS";
export const SET_USER_ACTIVE_PLAN_DETAILS = "SET_USER_ACTIVE_PLAN_DETAILS";
export const SET_SHOP_PROFILES = "SET_SHOP_PROFILES";
export const SET_USER_PLAN_TO_ACTIVE = "SET_USER_PLAN_TO_ACTIVE";
export const UPDATE_USER_CREDENTIALS = "UPDATE_USER_CREDENTIALS";
export const ADD_USER_MEDIA = "ADD_USER_MEDIA";
export const SET_USER_MEDIA = "SET_USER_MEDIA";

// Batch Content Loading
export const SET_BATCH_CONTENT_LOADING = "SET_BATCH_CONTENT_LOADING";
export const SET_UNAUTHORIZED_BATCH_ACCESS = "SET_UNAUTHORIZED_BATCH_ACCESS";
export const DELETE_USER_MEDIA = "DELETE_USER_MEDIA";
export const TOGGLE_TEMPLATE_FAVORITE = "TOGGLE_TEMPLATE_FAVORITE";
export const SET_SCHEDULED_POSTS_TOTAL_COUNT =
  "SET_SCHEDULED_POSTS_TOTAL_COUNT";
export const SET_DRAFTS = "SET_DRAFTS";
export const PREPEND_DRAFT = "PREPEND_DRAFT";
export const DELETE_DRAFT = "DELETE_DRAFT";
export const RENAME_DRAFT = "RENAME_DRAFT";
export const APPEND_DRAFTS = "APPEND_DRAFTS";
export const SET_ONBOARDING_CHECKLIST = "SET_ONBOARDING_CHECKLIST";

// UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const STOP_LOADING_UI = "STOP_LOADING_UI";
export const SET_UI_MESSAGE = "SET_UI_MESSAGE";
export const CLEAR_UI_MESSAGE = "CLEAR_UI_MESSAGE";

// Data reducer types
export const LOADING_DATA = "LOADING_DATA";
export const SET_GENERATED_URL = "SET_GENERATED_URL";
export const SET_PINTEREST_BOARDS = "SET_PINTEREST_BOARDS";
export const SET_SELECTED_BOARDS = "SET_SELECTED_BOARDS";
export const SET_BOARD_SECTIONS = "SET_BOARD_SECTIONS";
export const SET_DRAGGED_MEDIA = "SET_DRAGGED_MEDIA";
export const SET_AFFILIATE_DATA = "SET_AFFILIATE_DATA";
export const SET_WISE_TAG = "SET_WISE_TAG";
export const STOP_LOADING_DATA = "STOP_LOADING_DATA";
export const CLEAR_DATA = "CLEAR_DATA";
export const SET_ALL_POST_URLS = "SET_ALL_POST_URLS";
export const SET_USED_SITE_MAP = "SET_USED_SITE_MAP";
export const SET_SHOP_LISTINGS = "SET_SHOP_LISTINGS";
export const UPDATE_LISTING = "UPDATE_LISTING";
export const ADD_BOARD = "ADD_BOARD";
export const SET_PRICING_PARITY = "SET_PRICING_PARITY";
export const SET_NEW_TREND_ALERT_SETTINGS = "SET_NEW_TREND_ALERT_SETTINGS";
export const UPDATE_NEW_TREND_ALERT_SETTINGS =
  "UPDATE_NEW_TREND_ALERT_SETTINGS";
export const SET_USER_TREND_ALERTS = "SET_USER_TREND_ALERTS";
export const SET_RSS_FEEDS = "SET_RSS_FEEDS";
export const SET_ACTIVE_CATALOG = "SET_ACTIVE_CATALOG";
export const SET_ALL_CATALOGS = "SET_ALL_CATALOGS";
export const DELETE_CATALOG = "DELETE_CATALOG";
export const ADD_CATALOG = "ADD_CATALOG";
export const UPDATE_CATALOG = "UPDATE_CATALOG";
export const SET_CATALOG_ITEMS = "SET_CATALOG_ITEMS";
export const DELETE_CATALOG_ITEM_IMAGE = "DELETE_CATALOG_ITEM_IMAGE";
export const ADD_CATALOG_ITEM_IMAGE = "ADD_CATALOG_ITEM_IMAGE";
export const UPDATE_CATALOG_ITEM = "UPDATE_CATALOG_ITEM";
export const DELETE_CATALOG_ITEM = "DELETE_CATALOG_ITEM";

// Design reducer types
export const UPLOAD_IMAGES = "UPLOAD_IMAGES";
export const SET_HIDE_URL = "SET_HIDE_URL";
export const SET_POSTS = "SET_POSTS";
export const DELETE_POST = "DELETE_POST";
export const ADD_POSTS = "ADD_POSTS";
export const UPDATE_SINGLE_POST = "UPDATE_SINGLE_POST";
export const DELETE_SINGLE_POST_LAYER = "DELETE_SINGLE_POST_LAYER";
export const UPDATE_SINGLE_POST_LAYER = "UPDATE_SINGLE_POST_LAYER";
export const UPDATE_POST_TEMPLATE_LAYER = "UPDATE_POST_TEMPLATE_LAYER";
export const SET_DESIGN_COLORS = "SET_DESIGN_COLORS";
export const SET_COLOR_PALETTES = "SET_COLOR_PALETTES";
export const SET_FONT_ADJUSTMENT = "SET_FONT_ADJUSTMENT";
export const SET_IMAGE_POSITION = "SET_IMAGE_POSITION";
export const SET_IS_RANDOM_IMAGES = "SET_IS_RANDOM_IMAGES";
export const SET_IS_RANDOM_TEMPLATES = "SET_IS_RANDOM_TEMPLATES";
export const SET_TEMPLATE_SELECTIONS = "SET_TEMPLATE_SELECTIONS";
export const REMOVE_FROM_TEMPLATE_SELECTIONS =
  "REMOVE_FROM_TEMPLATE_SELECTIONS";
export const SET_IS_GENERATING = "SET_IS_GENERATING";
export const SET_USE_ALL_COLORS = "SET_USE_ALL_COLORS";
export const SET_SELECTED_COLOR_INDEX = "SET_SELECTED_COLOR_INDEX";
export const SET_FONT_FAMILY = "SET_FONT_FAMILY";
export const SET_FONT_COLOR = "SET_FONT_COLOR";
export const SET_USE_UPPER_CASE_FONT = "SET_USE_UPPER_CASE_FONT";
export const SET_GET_IMAGES_IN_ARTICLE = "SET_GET_IMAGES_IN_ARTICLE";
export const SET_DESIGN_SETTINGS = "SET_DESIGN_SETTINGS";
export const SET_IS_CONTAIN_IMAGES = "SET_IS_CONTAIN_IMAGES";
export const SET_POST_OVERRIDES = "SET_POST_OVERRIDES";
export const SET_ETSY_STORE_NAME = "SET_ETSY_STORE_NAME";
export const SET_IS_BULK_SCHEDULING = "SET_IS_BULK_SCHEDULING";
export const SET_OVERRIDE_COLORS_AND_FONT = "SET_OVERRIDE_COLORS_AND_FONT";
export const RESET_DESIGN_SETTINGS = "RESET_DESIGN_SETTINGS";
export const USE_ONE_OF_EACH_TEMPLATE_CHANGE =
  "USE_ONE_OF_EACH_TEMPLATE_CHANGE";
export const DUPLICATE_POST = "DUPLICATE_POST";
export const SET_USE_ALL_DETECTED_IMAGES = "SET_USE_ALL_DETECTED_IMAGES";
export const SET_SELECTED_DETECTED_IMAGES = "SET_SELECTED_DETECTED_IMAGES";
export const TOGGLE_SELECTED_DETECTED_IMAGES =
  "TOGGLE_SELECTED_DETECTED_IMAGES";
export const SET_LOADING_DESIGN_SETTINGS = "SET_LOADING_DESIGN_SETTINGS";
export const CREATE_POSTS_WITH_DESIGN_SETTINGS =
  "CREATE_POSTS_WITH_DESIGN_SETTINGS";
export const SET_SELECTED_UPLOADED_IMAGES = "SET_SELECTED_UPLOADED_IMAGES";
export const TOGGLE_SELECTED_UPLOADED_IMAGES =
  "TOGGLE_SELECTED_UPLOADED_IMAGES";
export const SET_AI_LANGUAGE = "SET_AI_LANGUAGE";
export const SET_AI_KEYWORDS = "SET_AI_KEYWORDS";
export const SET_AI_TONE = "SET_AI_TONE";
export const SET_AI_IMAGE_CUSTOM_PROMPT = "SET_AI_IMAGE_CUSTOM_PROMPT";
export const SET_SHOW_AI_IMAGE_CUSTOM_PROMPT =
  "SET_SHOW_AI_IMAGE_CUSTOM_PROMPT";
export const SET_INCLUDE_URL_IN_POST_TEXT = "SET_INCLUDE_URL_IN_POST_TEXT";
export const SET_AI_INCLUDE_HASHTAGS = "SET_AI_INCLUDE_HASHTAGS";
export const SET_UPLOADED_FONTS = "SET_UPLOADED_FONTS";
export const ADD_UPLOADED_FONT = "ADD_UPLOADED_FONT";
export const DELETE_UPLOADED_FONT = "DELETE_UPLOADED_FONT";
export const SET_FIX_LOW_CONTRAST_TEXT = "SET_FIX_LOW_CONTRAST_TEXT";
export const SET_USE_ONE_OF_EACH_IMAGE = "SET_USE_ONE_OF_EACH_IMAGE";
export const SET_DESIGN_SETTINGS_PROFILES = "SET_DESIGN_SETTINGS_PROFILES";
export const SET_DEFAULT_DESIGN_SETTINGS = "SET_DEFAULT_DESIGN_SETTINGS";
export const RENAME_DESIGN_PROFILE = "RENAME_DESIGN_PROFILE";
export const DELETE_DESIGN_PROFILE = "DELETE_DESIGN_PROFILE";
export const SET_PICKED_TEMPLATE = "SET_PICKED_TEMPLATE";
export const SET_BYPASSS_RESIZE = "SET_BYPASSS_RESIZE";
export const SET_GENERATE_ALT_TEXT_WITH_AI = "SET_GENERATE_ALT_TEXT_WITH_AI";
export const SET_GROUP_POSTS_BY = "SET_GROUP_POSTS_BY";
export const SET_SHOW_POST_TEXT = "SET_SHOW_POST_TEXT";

// Template reducer types
export const SET_TEMPLATES = "SET_TEMPLATES";
export const APPEND_TEMPLATES = "APPEND_TEMPLATES";
export const APPEND_STANDARD_TEMPLATES = "APPEND_STANDARD_TEMPLATES";
export const SET_SHARED_TEMPLATES = "SET_SHARED_TEMPLATES";
export const CLEAR_SHARED_TEMPLATES = "CLEAR_SHARED_TEMPLATES";
export const ADD_NEW_TEMPLATE = "ADD_NEW_TEMPLATE";
export const UPDATE_DESIGN_TEMPLATE = "UPDATE_DESIGN_TEMPLATE";
export const RESET_UNDO_REDO = "RESET_UNDO_REDO";
export const SET_DESIGN_TEMPLATE = "SET_DESIGN_TEMPLATE";
export const ADD_LAYER = "ADD_LAYER";
export const UPDATE_LAYER = "UPDATE_LAYER";
export const UPDATE_FONT_SIZE = "UPDATE_FONT_SIZE";
export const UPDATE_LAYER_COLOR = "UPDATE_LAYER_COLOR"; // We do this seperately to help with undo/redo performance
export const UPDATE_LAYERS = "UPDATE_LAYERS";
export const UPDATE_ZOOM = "UPDATE_ZOOM";
export const SET_INITIAL_TEMPLATE_SIZING = "SET_INITIAL_TEMPLATE_SIZING";
export const SET_SELECTED_LAYER_ID = "SET_SELECTED_LAYER_ID";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const UPDATE_TEMPLATE_SETTINGS = "UPDATE_TEMPLATE_SETTINGS";
export const ADJUST_FAVORITE_COUNT = "ADJUST_FAVORITE_COUNT";
export const CLEAR_TEMPLATES_DATA = "CLEAR_TEMPLATES_DATA";
export const REMOVE_SHARED_TEMPLATE = "REMOVE_SHARED_TEMPLATE";
export const SET_IS_LOADING_USER_TEMPLATES = "SET_IS_LOADING_USER_TEMPLATES";
export const SET_STANDARD_TEMPLATES = "SET_STANDARD_TEMPLATES";
export const SET_LOADING_STANDARD_TEMPLATES = "SET_LOADING_STANDARD_TEMPLATES";
export const SET_TEMPLATE_CATEGORIES = "SET_TEMPLATE_CATEGORIES";
export const SET_TEMPLATE_PACKS = "SET_TEMPLATE_PACKS";
